import React from 'react'

export default function Outlet({ children }) {
  return <div id="detail">{children}</div>
}
